// Core code

(function($) {
	
	var Chris_Taxis = {
		
		init : function() {
			this.onepage_nav();
			this.contact_form_events();
		},
		
		onepage_nav : function() {
			
			$('#main-nav li a[href*="#"], .section-content a[href*="#"]').on('click', function(e) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $($(this).attr('href')).offset().top,
				}, 500, 'linear');
			});
						
			$('#offcanvas-nav li a[href*="#"]').on('click', function(e) {
				e.preventDefault();
				var toggle = $('a[data-toggle="off-canvas"]');
				var link = $(this);
				toggle.click();
				setTimeout(function()
				{
					$('html, body').animate({
						scrollTop: $(link.attr('href')).offset().top,
					}, 1000, 'linear');
				}, 500);
			});
			
		},
		
		contact_form : function(type = '')
		{
				
			var form         = $('.home .wpcf7-form'),
				one_way      = form.find('input[value="One Way"]'),
				two_ways     = form.find('input[value="Two Ways"]'),
				options      = form.find('input[name="radio-450"]'),
				options_wrap = form.find('#ion-form-booking-options'),
				enquiry_type = form.find('select[name="menu-291"]'),
				taxi_one     = form.find('#ion-booking-route-one'),
				taxi_two     = form.find('#ion-booking-route-two'),
				title_one    = '<h3 id="ion-form-title-one" class="ion-form-title">First Journey</h3>',
				title_two    = '<h3 id="ion-form-title-two" class="ion-form-title">Second Journey</h3>',
				booking_info = form.find('.ion-form-boxed-label');
				
			if(type == '')
			{
				options_wrap.hide();
				taxi_one.hide();
				taxi_two.hide();
				booking_info.parent('div').hide().prev().hide();
			}
			
			if(type == 'select')
			{	
				if(enquiry_type.find('option:checked').val() == 'Booking Enquiry') {
					options_wrap.show();
					taxi_one.show();
					taxi_one.prepend(title_one);
					$('<em>*</em>').appendTo(taxi_one.find('label'));
					taxi_one.find('input').attr('aria-required', true);
					booking_info.parent('div').show().prev().show();
				} else if(enquiry_type.find('option:checked').val() == 'General Enquiry') {
					options_wrap.hide();
					taxi_one.hide();
					taxi_two.hide();
					form.find('#ion-form-title-one').remove();
					form.find('#ion-form-title-two').remove();
					one_way.attr('checked', 'checked');
					taxi_one.find('em').remove();
					taxi_one.find('input').removeAttr('required');
					booking_info.parent('div').hide().prev().hide();
				}
			}
			
			if(type == 'radio')
			{	
				var value = $(options).context.activeElement.value;
				if(value == 'Two Ways') {
					taxi_two.show();
					taxi_two.prepend(title_two);
					taxi_two.find('em').remove();
					$('<em>*</em>').appendTo(taxi_two.find('label'));
					taxi_two.find('input').attr('required', 'required');
				} else if(value == 'One Way') {
					form.find('#ion-form-title-two').remove();
					taxi_two.hide();
					taxi_two.find('em').remove();
					taxi_two.find('input').removeAttr('required');
				}
			}
			
		},
		
		contact_form_events : function()
		{
			
			var self         = this,
				options      = 'input[name="radio-450"]',
				enquiry_type = 'select[name="menu-291"]';
			
			self.contact_form();
			self.contact_form('select');
			$(enquiry_type).on('change', $(enquiry_type), function(){self.contact_form('select')});
			$(options).on('change', $(options), function(){self.contact_form('radio')});
			
		},
		
	};
	
	Chris_Taxis.init();

})(jQuery);